import { configureStore } from "@reduxjs/toolkit";
import matesSlice from "../reducer/getMates";

export const store = configureStore({
  reducer: {
    mates: matesSlice,
  },
});
